<template>
  <div>
    <div>
      <div class="text-4">Like to remain anonymous?</div>
      <div class="text-4 darkgray--text mt-1">
        Just connect your wallet to get started.
      </div>
    </div>
    <div
      class="mt-3 d-flex flex-column flex-sm-row align-sm-center justify-sm-space-between"
    >
      <div class="d-flex">
        <div class="wallet-item mr-3" v-for="item in wallets" :key="item.name">
          <img
            :src="$vuetify.theme.dark ? item.logoDark || item.logo : item.logo"
            :alt="item.name"
          />
        </div>
        <div class="wallet-item">
          <v-icon x-small color="primary">fa-ellipsis-h</v-icon>
        </div>
      </div>
      <div class="mt-3 mt-sm-0 d-flex justify-center">
        <c-btn is-secondary @click="showConnectWalletModal"
          >Connect Wallet</c-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import wallets from "@/common/config/wallets";
export default {
  methods: {
    showConnectWalletModal() {
      this.$store.dispatch("showSelectWalletModal");
    },
  },
  data: () => ({
    wallets: wallets.slice(0, 4),
  }),
};
</script>

<style lang="scss" scoped>
.wallet-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(246, 96, 51, 0.1);
  img {
    height: 55%;
  }
}
</style>
